import { render, staticRenderFns } from "./MyPanelTaskList.vue?vue&type=template&id=dcd371dc"
import script from "./MyPanelTaskList.vue?vue&type=script&lang=js"
export * from "./MyPanelTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports